var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceBattery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_250_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.611 33.5063C66.5535 40.0614 64.5645 46.4527 60.8948 51.875C57.225 57.2973 52.0385 61.508 45.9889 63.9766C39.9393 66.4452 33.2972 67.0612 26.8994 65.7471C20.5016 64.4329 14.6344 61.2473 10.0371 56.5918C5.4397 51.9362 2.31786 46.0189 1.06486 39.5854C-0.188133 33.1519 0.483781 26.49 2.99595 20.4392C5.50811 14.3884 9.74813 9.21924 15.1818 5.58313C20.6154 1.94702 26.9996 0.00660209 33.53 0.00634766C42.3036 0.00634766 50.7179 3.50498 56.9218 9.73258C63.1257 15.9602 66.611 24.4066 66.611 33.2138",
    fill: "#F47C3B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2084 25.8262H15.3867V21.9496H18.9571V18.6581H24.4221V21.9496H42.5656V18.585H47.6662C47.6662 18.585 48.0306 18.585 48.0306 19.1701C48.1032 19.9242 48.1032 20.6835 48.0306 21.4376C48.0306 22.0227 48.0306 22.3153 48.8321 22.2422C49.6336 22.169 50.8723 21.9496 51.601 21.9496V25.5337H49.8522V47.4769H17.2084V25.8262ZM33.5303 35.0424C34.769 33.1406 35.862 31.3852 37.1007 29.5566H30.1785C30.1785 29.5566 29.7413 29.5566 29.7413 30.1417C29.7413 30.7269 29.0126 32.1898 29.0126 33.2869C29.0126 34.3841 28.4297 35.5544 28.1382 36.871H33.6032L30.5428 43.0882L38.8495 35.0424H33.5303Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_250_5242",
    x: 0.450195,
    y: 0.00634766,
    width: 66.1611,
    height: 70.4148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_250_5242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBattery);
export default __webpack_public_path__ + "static/media/serviceBattery.1ef1b08ebb942742e7f2455d9cead9e6.svg";
export { ForwardRef as ReactComponent };